import { Component, Input } from '@angular/core';
import { ICardStatus } from '../shared/models/models';

@Component({
    selector: 'dl-device-status-bar',
    templateUrl: './device-status-bar.component.html',
    styleUrls: ['./device-status-bar.component.scss']
})
export class DeviceStatusBarComponent {
    @Input() status: ICardStatus;
}
